<!--
 * @Description:附件上传弹窗
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
-->
<template>
  <jw-modal class="ly-upload-modal" title-align="start" v-model:visible="data.modalVisible" width="700px" unmount-on-close :on-before-ok="handleOk" @cancel="handleCancel" :ok-loading="data.saveLoading">
    <template #title> {{ $t('上传附件') }} </template>

    <fh-attachment-upload :fieldExt="data.fileItem?.fieldExt" v-model="data.fileItem.fieldValue" :defaultFileList="data.fileItem?.fieldValue" class="system-formlumns-item-value" @cb="getUploadItem($event, fileList)" :showBorder="false" :btnBorder="true" />
  </jw-modal>
</template>

<script setup>
import { reactive } from 'vue';
import { useI18n } from 'vue-i18n';
import { Message } from '@arco-design/web-vue';
const { t } = useI18n();
import { tools } from '@/utils/tools';
import useEditFields from '@/hooks/edit-field';
const { editField } = useEditFields();
const emits = defineEmits(['cb']);
const props = defineProps({
  opType: {
    //操作类型 0：快捷编辑，1：行内编辑
    type: String || Number,
    required: 0
  }
});
const data = reactive({
  modalVisible: false,
  fileItem: {},
  saveLoading: false,
  allFiles: [],
  filesList: [],
  oldFieldValue: []
});

// 确定
const handleOk = async () => {
  //   console.log('done', done);
  //   console.log('data.filesList', data.filesList);
  //   console.log('data.fileItem111', data.fileItem.fieldValue);
  // eslint-disable-next-line no-debugger
  // debugger;
  data.saveLoading = true;
  if (data.filesList && data.allFiles && data.filesList?.length != data.allFiles?.length) {
    data.saveLoading = false;

    Message.warning(t('文件未上传完成,请稍后提交！'));
    return false;
  }
  if (props.opType == 0) {
    //快捷编辑

    if (data.fileItem?.isRequired && data.filesList?.length == 0 && (!data.fileItem.fieldValue || data.fileItem.fieldValue?.length == 0)) {
      //必填校验
      Message.warning('必填字段不能为空!');
      data.modalVisible = false;
      data.saveLoading = false;
      emits('cb', {
        fieldValue: data.oldFieldValue?.length > 0 ? JSON.stringify(data.oldFieldValue) : ''
      });
      return;
    }
    const uploadFieldValue = data.filesList?.length > 0 ? data.filesList : data.fileItem.fieldValue;

    uploadFieldValue?.forEach((fItem) => {
      console.log('附件列表', fItem);
      // 数据日志收集不接收default参数
      if (fItem.default) {
        delete fItem.default;
      }
    });

    const params = {
      //   entity: data.fileItem.entity,
      entity: data.fileItem.isSubForm ? data.fileItem.subEntityId : data.fileItem.entity,
      fieldKey: data.fileItem.fieldKey,
      businessId: data.fileItem.businessId,
      fieldValue: uploadFieldValue?.length > 0 ? JSON.stringify(uploadFieldValue) : '',
      apiIndex: data.fileItem.entity + Math.random()
    };

    await editField(params)
      .then((res) => {
        data.saveLoading = false;
        if (!res.error) {
          //编辑成功
          Message.success('保存成功');
          data.modalVisible = false;
          emits('cb', { fieldValue: params.fieldValue });
        }
      })
      .catch((err) => {
        data.saveLoading = false;
        data.modalVisible = false;
        console.log(err);
      });
  } else {
    //行内编辑
    data.modalVisible = false;
    data.saveLoading = false;
    emits('cb', data.allFiles);
  }
};
// 取消
const handleCancel = () => {
  data.modalVisible = false;
  if (props.opType == 0) {
    //快捷编辑
    emits('cb', {
      fieldValue: data.oldFieldValue?.length > 0 ? JSON.stringify(data.oldFieldValue) : '',
      isCancel: true
    });
  }
};
// 打开上传
const openModal = (record) => {
  data.modalVisible = true;
  data.fileItem = record;
  data.fileItem.fieldExt = record?.fieldExt && tools.isJSON(record?.fieldExt) ? JSON.parse(record?.fieldExt) : { limit: 10, accept: [0] };
  data.fileItem.fieldValue = record?.fieldValue && tools.isJSON(record?.fieldValue) ? JSON.parse(record?.fieldValue) : record?.fieldValue?.length > 0 ? record?.fieldValue : null;
  data.fileItem.fieldValue?.forEach((el) => {
    el.default = true;
  });
  data.oldFieldValue = JSON.parse(JSON.stringify(data.fileItem.fieldValue));
};
// 上传的回调
const getUploadItem = async (files) => {
  console.log('上传回调', files);
  data.saveLoading = true;
  data.filesList = [];
  data.allFiles = files;

  files &&
    files.length > 0 &&
    files?.forEach((v) => {
      if (v?.response?.code == 0 && v.response?.data) {
        const url = v.response?.data;
        data.filesList.push(...url);
      }
      if (v.default) {
        //默认的附件
        data.filesList.push({ name: v.name, url: v.url });
      }
    });
  data.fileItem.fieldValue = data.filesList;
  console.log('上传回调2', data.filesList);

  data.saveLoading = false;
};
defineExpose({ openModal });
</script>
<style scoped lang="less">
@import './fh-upload-modal.less';
</style>
<style lang="less">
.ly-upload-modal {
  .arco-modal-body {
    height: 450px;
    padding-top: 8px;
    padding-right: 10px;
    overflow-y: scroll;

    .cloud-list-com,
    .cloud-item-list,
    .upload-list,
    .arco-upload-list {
      max-height: 400px;
    }

    .upload-button-container {
      padding: 8px 0 0 0;
    }

    .attach-editor-cover {
      right: -10px;
      bottom: -10px;
    }
  }
}
</style>
